import { getFormattedProduct } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackRemoveFromCart = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackRemoveFromCartEvent = useCallback(
    (cartInfo) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (cartInfo) {
          const { couponName } = cartInfo;

          window.webengage.track(
            "remove_from_cart",
            getFormattedProduct(cartInfo, couponName)
          );
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackRemoveFromCartEvent };
};

export default useTrackRemoveFromCart;
